// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__cgiVr","selection":"Footer_selection__BZlXR","buttons":"Footer_buttons__QMDpu","toggleButton":"Footer_toggleButton__8NiBV"};